import React from 'react';
import type { IForm } from '@lt/components/components/Form';
import Form from '@lt/components/components/Form';
import type { CustomerStateType } from 'src/routes/Checkout/store/domains/customer/types';
import {
  CustomerSchemaInternational,
  CustomerSchemaRu,
} from '../../../../../../store/domains/customer/schema';
import { CustomerForm } from './CustomerForm';
import type { Citizenship } from '../../types';

type CustomerFormWrapperProps = {
  saveCustomerInfo: (customerInfo: CustomerStateType) => void;
  citizenships: Citizenship[];
  touristData: CustomerStateType;
  isMobile: boolean;
  showFillerButton: boolean;
  initialValues: CustomerStateType;
  onSubmit: () => void;
  mobileSubmitBtnDisabled: boolean;
  customerInfo: CustomerStateType;
};

const CustomerFormWrapper = (props: CustomerFormWrapperProps) => {
  const {
    saveCustomerInfo,
    touristData,
    citizenships,
    isMobile,
    showFillerButton,
    initialValues,
    onSubmit,
    mobileSubmitBtnDisabled,
    customerInfo,
  } = props;

  const formikConfig: IForm<CustomerStateType>['formik'] = {
    initialValues,
    validationSchema:
      customerInfo.docType === 'internal_passport'
        ? CustomerSchemaRu
        : CustomerSchemaInternational,
    // onSubmit требует формик, но мы сохраняем данные на блюр поля
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onSubmit: () => {},
  };

  return (
    <Form formik={formikConfig}>
      <CustomerForm
        showFillerButton={showFillerButton}
        saveCustomerInfo={saveCustomerInfo}
        isMobile={isMobile}
        touristData={touristData}
        citizenships={citizenships}
        onSubmit={onSubmit}
        mobileSubmitBtnDisabled={mobileSubmitBtnDisabled}
      />
    </Form>
  );
};

export default CustomerFormWrapper;
